module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reports-root container"
  }, [(_vm.$route.path === "/reports") ? [_c('h1', [_vm._v("报表")]), _c('rooms')] : _vm._e(), _c('router-view')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e0abad8","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/reports/Root.vue
// module id = 546
// module chunks = 0